<ng-container *ngIf="useNewIndicator$ | async; else bespokeDot">
  <app-cw-robot-status-dot
    [projectId]="projectId"
    [callsign]="callsign"
    [size]="size"
    [dark]="dark"
    [deploymentStatus]="deploymentStatus"
  ></app-cw-robot-status-dot>
</ng-container>

<ng-template #bespokeDot>
  <!-- A virtual robot that isn't running yet: show its deployment state, since the heartbeat dot
       below only reflects a live robot. `success`/`provisioning` fall through to the heartbeat. -->
  <ng-container *ngIf="bespokeDeploymentDisplay as deployment; else liveDot">
    <ng-container [ngSwitch]="deployment">
      <div *ngSwitchCase="'deploying'" class="center-spinner">
        <app-loading-spinner [isLoading]="true"></app-loading-spinner>
      </div>
      <span
        *ngSwitchCase="'failed'"
        class="deployment-dot failed"
        role="img"
        aria-label="Deployment failed"
        matTooltip="Deployment failed"
      ></span>
      <span
        *ngSwitchCase="'unknown'"
        class="deployment-dot unknown"
        role="img"
        aria-label="Deployment status unknown"
        matTooltip="Deployment status unknown"
      ></span>
    </ng-container>
  </ng-container>

  <ng-template #liveDot>
    <ng-container *ngIf="status !== 'unknown'">
      <app-status-dot [status]="status" [size]="size" [dark]="dark" appTestID="robot-status-dot"></app-status-dot>
    </ng-container>
    <ng-container *ngIf="status === 'unknown'">
      <div class="center-spinner">
        <app-loading-spinner [isLoading]="true"></app-loading-spinner>
      </div>
    </ng-container>
  </ng-template>
</ng-template>
